let baseUrl = "";
let baseUrlOrigin = "";
export const WebSocketURL = "wss://intikom-admin.digimasia.com/ws";

const environment = import.meta.env.VITE_ENVIRONMENT;

if (environment === "production") {
  baseUrl =
    "https://intikom-admin.digimasia.com/api/public/index.php";
    baseUrlOrigin = "https://intikom-admin.digimasia.com"
} else if (environment === "staging") {
  baseUrl =
    "https://intikom-admin.digimasia.com/api/public/index.php";
    baseUrlOrigin = "https://intikom-admin.digimasia.com"
} else {
  baseUrl =
    "https://intikom-admin.digimasia.com/api/public/index.php";
    baseUrlOrigin = "https://intikom-admin.digimasia.com"
}

export { baseUrlOrigin };
export default baseUrl;
